import { create } from 'apisauce'

const api = create({
    baseURL : process.env.REACT_APP_IP_BACKEND + ':' + process.env.REACT_APP_PORT_BACKEND ,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, DELETE, OPTIONS",
        "key" : process.env.REACT_APP_BACKEND_KEY ,
    }
})


api.addResponseTransform(response => {

})

api.addAsyncRequestTransform(request => async () => {
      //  request.headers["key"] = `AZZVK5klnmJfijRVtoRtToZyEjl129zx`
        
})

export default api